import { render, staticRenderFns } from "./TermsAndConditions.vue?vue&type=template&id=b494972c&scoped=true&"
import script from "./TermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./TermsAndConditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b494972c",
  null
  
)

export default component.exports